import { Controller } from "@hotwired/stimulus"

// Lightweight inline search. Submits the form on Enter and previews results
// via Turbo Stream when the input is typed into. The server falls back to a
// plain HTML response if Meilisearch is unavailable.
export default class extends Controller {
  static targets = ["input"]
  static values = { url: String }

  preview(event) {
    // Reserved for instant-search Turbo Stream behaviour.
    // We submit on Enter for now to keep the implementation lean.
  }

  submit(event) {
    if (event.key === "Enter") {
      this.element.requestSubmit()
    }
  }
}
